// 认证模块 API
// src/api/auth.js
import request from '@/utils/request'
import { saveToken, clearToken } from '@/utils/request'

// 登录
export const login = (name, password) => {
  return request({
    method: 'post',
    url: '/auth/login',
    data: { name, password },
    _skipAuth: true          // 登录请求不需要 Token
  })
}

// 注册
export const register = (data) => {
  return request({
    method: 'post',
    url: '/auth/register',
    data,
    _skipAuth: true
  })
}

// 刷新 Token
export const refreshToken = (refreshToken) => {
  return request({
    method: 'post',
    url: '/auth/refresh',
    data: { refreshToken },
    _skipAuth: true
  })
}

// 登出
export const logout = () => {
  return request({
    method: 'post',
    url: '/auth/logout',
    _skipAuth: true
  })
}

// 判断是否有accessToken
export const getToken = () => {
  return localStorage.getItem('accessToken')
}

export {saveToken, clearToken}
